import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import Common from "../../helper/common";
import { Button } from "../../components/ui/button";
import AdvanceTable from "../../components/advanceTable";
import {
  HolidayTypeEnum,
  ViewDateTimeFormat,
  ResultStatus,
} from "../../constants/appConstant";
import { useNavigate } from "react-router-dom";
import { useQueryParams } from "../../contexts/queryParamsContext";

const ClubHolidayRecurrings = () => {
  const [data, setData] = useState({});
  const navigate = useNavigate();
  const { params, setParams, resetParams } = useQueryParams();

  useEffect(() => {
    getData(1);
  }, []);

  const getData = async (
    pageNumber,
    searchTerm = "",
    recordsToDisplay = null
  ) => {
    try {
      const response = await Common.ApiService.getInstance().request(
        "GetClubHolidayRecurring",
        {
          pageNumber: pageNumber,
          search_term: searchTerm,
          recordsToDisplay,
          type: HolidayTypeEnum.Club,
        },
        "Post"
      );
      
      if (response?.status === ResultStatus.Success && response?.data) {        
        let obj = {
          ...response.data[0],
          data: response.data[0].data.map((item) => {
            console.log("Processing item:", item);
            return {
              ...item,
              startDate: `${Common.moment(item.start_date).format(
                ViewDateTimeFormat
              )}`,
              endDate: `${Common.moment(item.end_date).format(ViewDateTimeFormat)}`,
              daysofweek: item.daysofweek ? item.daysofweek.split(',').length : 0,
              totalslots: item.recurringTimes ? item.recurringTimes.length : 0,
              isActive: item.is_active ? "Active" : "Inactive",
            };
          }),
        };

        setData(obj);
      } else {
        setData({ data: [], totalRecords: 0, currentPage: 1, totalPages: 0 });
      }
    } catch (error) {
      Common.SweetAlert.alert("Failed to load recurring holidays", "error");
      setData({ data: [], totalRecords: 0, currentPage: 1, totalPages: 0 });
    }
  };

  const _handleDelete = async (id) => {
    const isConfirmed = await Common.SweetAlert.confirmation(
      "Are you sure you want to delete this recurring holiday?",
      "Delete Recurring Holiday"
    );
    if (isConfirmed) {
      try {
        let resp = await Common.ApiService.getInstance().request(
          `DeleteClubHolidayRecurring?id=${id}`,
          {},
          "Delete"
        );
        
        if (resp?.status === ResultStatus.Success) {
          Common.SweetAlert.alert(resp.message, "success");
          setTimeout(() => {
            getData(1);
          }, 500);
        } else {
          Common.SweetAlert.alert(resp?.message || "Failed to delete recurring holiday", "error");
        }
      } catch (error) {
        console.error("Error deleting recurring holiday:", error);
        Common.SweetAlert.alert("Failed to delete recurring holiday", "error");
      }
    }
  };

  const _addUpdateTrigger = () => (
    <Button size="icon" variant="outline" color="secondary" className="h-7 w-7">
      <Icon icon="heroicons:pencil" className="h-4 w-4" />
    </Button>
  );

  const _addBtn = () => (
    <Button
      onClick={() => {
        resetParams();
        navigate("/app/addclubholidayrecurring");
      }}
    >
      <span className="text-xl mr-1">
        <Icon icon="icon-park-outline:plus" />
      </span>
      Add Recurring Holiday
    </Button>
  );

  const actions = [
    {
      type: "edit",
      onClick: (val) => {
        setParams({ ...params, clubHolidayRecurringId: val.id });
        navigate(`/app/addclubholidayrecurring`);
      },
    },
    {
      type: "delete",
      onClick: (val) => _handleDelete(val.id),
    },
  ];

  const renderActionButtons = (val) => (
    <div className="flex items-center">
      <Button
        size="icon"
        variant="outline"
        onClick={() => actions[0].onClick(val)}
      >
        <Icon icon="heroicons:pencil" className="h-4 w-4" />
      </Button>
      <Button
        size="icon"
        variant="outline"
        className="ml-2"
        onClick={() => actions[1].onClick(val)}
      >
        <Icon icon="heroicons:trash" className="h-4 w-4" />
      </Button>
    </div>
  );

  let columns = [
    { title: "From Date", type: "text", key: "startDate" },
    { title: "Till Date", type: "text", key: "endDate" },
    { title: "Reason", type: "text", key: "reason" },
    { title: "No. of Days", type: "number", key: "daysofweek" },
    { title: "Time Slots", type: "number", key: "totalslots" },
  ];

  return (
    <>
      {data?.data && (
        <AdvanceTable
          title={"Club Holiday Recurrings"}
          columns={columns}
          data={data}
          getData={getData}
          addButton={_addBtn}
          showPagination
          showAddButton
          actionButtons={actions}
          updateTrigger={_addUpdateTrigger}
        />
      )}
    </>
  );
};

export default ClubHolidayRecurrings;
